
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overviews",
      function () {
        return require("private-next-pages/overviews/index.tsx");
      }
    ]);
  